import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyStateIllustration = ({
  width = 100
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(ResultsMessage, {
      illustration: "empty-state-charts",
      illustrationProps: {
        width
      },
      marginBlockEnd: "-500"
    })
  });
};
export default EmptyStateIllustration;